import React, { useContext } from "react";
import {
  BlockToken,
  CampaignContainer,
  CampaignLeft,
  CampaignRight,
  CampaignWrapper,
} from "./styled";
import { ButtonCommon } from "../../../Layout/styled";
import { Link } from "react-router-dom";
import { ContextProviderWrapper } from "../../../components/Context";
import { Campaigns } from "../../Avax/Leaderboard/styled";

const Campaign = () => {
  const { theme } = useContext(ContextProviderWrapper)!;
  return (
    <CampaignContainer>
      <CampaignWrapper>
        <div className="campaign-inner">
          <CampaignLeft className={theme}>
            <div className="block-heading">
              <div className="heading-left">
                <img
                  src="/assets/images/campaign/campaign_img_01.png"
                  width={100}
                  height={100}
                  loading="lazy"
                  alt="Campain DOPPAChain"
                  className="heading-image"
                />
                <div className="content-heading">
                  <h2 className="title-heading">Campain DOPPAChain</h2>
                  <BlockToken>
                    <div className="token-inner">
                      {listToken.slice(0, 2).map((item: any, index: number) => (
                        <img
                          key={index}
                          src={item.icon}
                          width={32}
                          height={32}
                          loading="lazy"
                          alt="Icon"
                        />
                      ))}
                      {listToken.length > 2 && (
                        <div className="more">{listToken.length - 2}+</div>
                      )}
                    </div>
                    <span className="people">19k</span>
                    <span className="part">Participants</span>
                  </BlockToken>
                </div>
              </div>
              <ButtonCommon
                background={theme === "light" ? "#EEEEF0" : "#43424A"}
                style={{ color: theme === "light" ? "#230B34" : "#fff" }}
              >
                <img
                  src={
                    theme === "light"
                      ? "/assets/images/campaign/icn_share_light.svg"
                      : "/assets/images/campaign/icn_share.svg"
                  }
                  width={16}
                  height={16}
                  loading="lazy"
                  alt="Share"
                />
                Share
              </ButtonCommon>
            </div>
            <div className="block-detail">
              <h2 className="title-detail">MISSION BRING DOPA HOME</h2>
              <ul className="list-tags">
                <li>On going</li>
                <li>2022/12/07 12:00 (UTC+07:00) ~ N/A</li>
              </ul>
              <div className="block-swap">
                <p>MAKE A SWAPPPPP BRO !!!!! </p>
                <ButtonCommon
                  background={theme === "light" ? "#EEEEF0" : "#43424A"}
                  style={{ color: theme === "light" ? "#230B34" : "#fff" }}
                >
                  Claim Now
                </ButtonCommon>
              </div>
            </div>
            <div className="block-desc">
              <h3>Descritption</h3>
              <p>
                As the crypto ecosystem awaits the launch of DOPPAChain, we’re
                teaming up with Kibble to help users show their support for the
                DOPAChain ecosystem and explore the power of omnichain
                functionality.
              </p>
              <p>
                As the crypto ecosystem awaits the launch of DOPPAChain, we’re
                teaming up with Kibble to help users show their support for the
                DOPAChain ecosystem and explore the power of omnichain
                functionality.
              </p>
            </div>
            <div className="block-suggest">
              <h3>For you</h3>
              <Campaigns className={theme}>
                <div className="block-campaign">
                  {listCampaign.map((items, index) => (
                    <div className="item-campaign" key={index}>
                      <img
                        src={items.imageBanner}
                        width={501}
                        height={117}
                        loading="lazy"
                        alt="Campaign"
                        className="image-camp"
                      />
                      <div className="block-title-campaign">
                        <h3 dangerouslySetInnerHTML={{ __html: items.title }} />
                        <p className="price">{items.price}</p>
                      </div>
                      <div className="block-des">
                        <p>{items.des}</p>
                        <ul className={`list-social ${theme}`}>
                          {items.listSocial.map((item, index) => (
                            <li key={index}>
                              <Link to={item.link} className="trans">
                                <img
                                  src={theme ? item.iconLight : item.icon}
                                  width={10}
                                  height={10}
                                  loading="lazy"
                                  alt="Social"
                                />
                              </Link>
                            </li>
                          ))}
                        </ul>
                      </div>
                      <div className="block-join">
                        <div className="join-left">
                          <img
                            src={items.imageUser}
                            width={24}
                            height={24}
                            loading="lazy"
                            alt={items.nameUser}
                            className="image-user"
                          />
                          <div className="user-info">
                            <span className="host">{items.nameHosted}</span>
                            <span className="name-user">{items.nameUser}</span>
                          </div>
                        </div>
                        <div className="join-right">
                          <ul className="list-user">
                            {items.listImageUser.map((item, index) => (
                              <li key={index}>
                                <img
                                  src={item}
                                  width={24}
                                  height={24}
                                  loading="lazy"
                                  alt="user"
                                />
                              </li>
                            ))}
                          </ul>
                          <div className="total-people">
                            <span className="number">{items.totalUser}</span>
                            <span className="part">{items.text}</span>
                          </div>
                        </div>
                      </div>
                      <div className={`block-button ${theme}`}>
                        <ButtonCommon
                          background="#43424A"
                          as={Link}
                          to="/campaign"
                        >
                          View Profile
                        </ButtonCommon>
                      </div>
                    </div>
                  ))}
                </div>
              </Campaigns>
            </div>
          </CampaignLeft>
          <CampaignRight className={theme}>
            <div className="block-rewards">
              <h2 className="title-rewards">RewardS</h2>
              <div className="detail-rewards">
                <h3 className="title-detail">Make a Swap</h3>
                <img
                  src="/assets/images/campaign/campaign_img_02.png"
                  width={120}
                  height={120}
                  loading="lazy"
                  alt="Make a Swap"
                  className="image-swap"
                />
                <p className="point">
                  Point:
                  <span>
                    <img
                      src="/assets/images/leaderboard/icn_point.svg"
                      width={16}
                      height={16}
                      loading="lazy"
                      alt="Point"
                    />
                    50 points
                  </span>
                </p>
                <p className="chain">
                  <img
                    src="/assets/images/campaign/icn_avax.svg"
                    width={16}
                    height={16}
                    loading="lazy"
                    alt="AVAX CHAN"
                  />
                  AVAX CHAN
                </p>
              </div>
            </div>
            <div className="block-user">
              <h3 className="title-user">TOP USERS ACTIVE</h3>
              <ul className="list-user">
                {listUser.map((item, index) => (
                  <li key={index}>
                    <div className="user-left">
                      <img
                        src={item.img}
                        width={32}
                        height={32}
                        loading="lazy"
                        alt={item.name}
                      />
                      <div className="user-info">
                        <h4 className="name">{item.name}</h4>
                        <p className="time">{item.time}</p>
                      </div>
                    </div>
                    <p className="user-point">{item.point} points</p>
                  </li>
                ))}
              </ul>
            </div>
          </CampaignRight>
        </div>
      </CampaignWrapper>
    </CampaignContainer>
  );
};

const listToken = [
  {
    icon: "/assets/images/leaderboard/icn_domy_01.png",
  },
  {
    icon: "/assets/images/leaderboard/icn_domy_02.png",
  },
  {
    icon: "/assets/images/leaderboard/icn_domy_03.png",
  },
  {
    icon: "/assets/images/leaderboard/icn_domy_04.png",
  },
  {
    icon: "/assets/images/leaderboard/icn_domy_05.png",
  },
  {
    icon: "/assets/images/leaderboard/icn_domy_05.png",
  },
];
const listCampaign = [
  {
    imageBanner: "/assets/images/leaderboard/leaderboard_img_01.png",
    title: "Get Start",
    price: "$10000",
    des: "Short Discription for Campain",
    listSocial: [
      {
        icon: "/assets/images/leaderboard/icn_social_01.svg",
        iconLight: "/assets/images/leaderboard/icn_social_01_light.svg",
        link: "#",
      },
      {
        icon: "/assets/images/leaderboard/icn_social_02.svg",
        iconLight: "/assets/images/leaderboard/icn_social_02_light.svg",
        link: "#",
      },
      {
        icon: "/assets/images/leaderboard/icn_social_03.svg",
        iconLight: "/assets/images/leaderboard/icn_social_03_light.svg",
        link: "#",
      },
    ],
    imageUser: "/assets/images/leaderboard/leaderboard_img_02.png",
    nameHosted: "Hosted by",
    nameUser: "MR.Avocado",
    listImageUser: [
      "/assets/images/leaderboard/leaderboard_img_03.png",
      "/assets/images/leaderboard/leaderboard_img_04.png",
    ],
    totalUser: "19k",
    text: "Participants",
  },
  {
    imageBanner: "/assets/images/leaderboard/leaderboard_img_01.png",
    title: "Get Start",
    price: "$10000",
    des: "Short Discription for Campain",
    listSocial: [
      {
        icon: "/assets/images/leaderboard/icn_social_01.svg",
        iconLight: "/assets/images/leaderboard/icn_social_01_light.svg",
        link: "#",
      },
      {
        icon: "/assets/images/leaderboard/icn_social_02.svg",
        iconLight: "/assets/images/leaderboard/icn_social_02_light.svg",
        link: "#",
      },
      {
        icon: "/assets/images/leaderboard/icn_social_03.svg",
        iconLight: "/assets/images/leaderboard/icn_social_03_light.svg",
        link: "#",
      },
    ],
    imageUser: "/assets/images/leaderboard/leaderboard_img_02.png",
    nameHosted: "Hosted by",
    nameUser: "MR.Avocado",
    listImageUser: [
      "/assets/images/leaderboard/leaderboard_img_03.png",
      "/assets/images/leaderboard/leaderboard_img_04.png",
    ],
    totalUser: "19k",
    text: "Participants",
  },
];
const listUser = [
  {
    img: "/assets/images/campaign/icn_user.png",
    name: "Mìmý",
    time: "1 minute ago",
    point: 2345,
  },
  {
    img: "/assets/images/campaign/icn_user.png",
    name: "Mìmý",
    time: "1 minute ago",
    point: 2345,
  },
  {
    img: "/assets/images/campaign/icn_user.png",
    name: "Mìmý",
    time: "1 minute ago",
    point: 2345,
  },
  {
    img: "/assets/images/campaign/icn_user.png",
    name: "Mìmý",
    time: "1 minute ago",
    point: 2345,
  },
  {
    img: "/assets/images/campaign/icn_user.png",
    name: "Mìmý",
    time: "1 minute ago",
    point: 2345,
  },
];
export default Campaign;
